<div class="portal-theme portal" c-main>
    <div style="height: 45px;"></div>
    <style>
        ul.tree li {
            margin-left: 24px;
        }
        ul.tree .expander,
        ul.tree .spacer {
            display: inline-block;
            width: 24px;
        }

    </style>
    <iframe ng-src="{{frameSource}}" sandbox="allow-same-origin allow-top-navigation allow-forms allow-scripts allow-popups allow-popups-to-escape-sandbox ms-allow-popups"></iframe>
</div>